import {
  ContractLinkCreateAction,
  contractLinkCreateLoadPdfSuccess,
} from '@app/features/contractLink/contractLinkCreate';
import * as TYPES from '@app/store/actionTypes';
import { TemplateAction } from '@app/store/template/actions';

type TemplateFileIdState = string | null;

const initialState: TemplateFileIdState = null;

export default function reducer(
  state: TemplateFileIdState = initialState,
  action: TemplateAction | ContractLinkCreateAction
) {
  switch (action.type) {
    case TYPES.TEMPLATE_CLEAR_ALL_STATE:
      return initialState;
    case contractLinkCreateLoadPdfSuccess.type:
    case TYPES.TEMPLATE_CREATE__PDF_LOAD_SUCCESS:
    case TYPES.TEMPLATE_FILE_CHANGE__PDF_LOAD_SUCCESS:
      return action.payload.fileId;
    default:
      return state;
  }
}
